/**
 * @module hoverTouch
 *
 * @description  
 * <p>The hoverTouch module adds the 'can-touch' class to document root in real-time on a touch event and turns it off on a non-touch event.</p>
 * <p>Disabling hover effects on touch enabled devices used to be safe as only mobile devices used touch and they didn't use any other user input type.
 * However, now there are tablets, laptops and even full desktop devices that support touch as well as mouse inputs.</p>
 * <p>Adding this module to your project handles distinguishing between a touch and a mouse hover in your css by just using the root class of 'can-touch' to remove your hover effects.</p>
 *
 * @example <caption>CSS</caption>
 * {@lang css}
 * #hoverexample a{
 * 	display: block;
 *	padding: 10px;
 *	border: 1px solid red;
 *	text-decoration: none;
 * }
 * html:not(.can-touch) #hoverexample a:hover{
 * 	background: yellow;
 * }
 *
 * @example <caption>SASS</caption>
 * {@lang css}
 * #hoverexample a{
 * 	display: block;
 *	padding: 10px;
 *	border: 1px solid red;
 *	text-decoration: none;
 * 
 * 	html:not(.can-touch) &:hover{
 * 		background: yellow;
 *  }
 */
;(function(){
	"use strict";

	var isTouch = false,            // current input type (is touch versus no touch) 
		isTouchTimer,               // timeout variable
		curRootClass = '',          // current document root class ("can-touch" or "")
		touchClass = 'can-touch';   // class to apply for touch-based event
	 
	function addTouchClass(e){
		clearTimeout(isTouchTimer);
		isTouch = true;
		if (curRootClass != touchClass){    // add "can-touch' class if it's not already present
			curRootClass = touchClass;
			document.documentElement.classList.add(touchClass);
		}
		isTouchTimer = setTimeout(function(){isTouch = false;}, 1000);   // maintain "istouch" state for 1000ms so removetouchclass doesn't get fired immediately following a touch event
	}
	 
	function removeTouchClass(e){
		if (!isTouch && curRootClass == touchClass){    // remove 'can-touch' class if not triggered by a touch event and class is present
			curRootClass = '';
			document.documentElement.classList.remove(touchClass);
		}
	}
	 
	document.addEventListener('touchstart', addTouchClass, false);      // this event only gets called when input type is touch
	document.addEventListener('mouseover', removeTouchClass, false);    // this event gets called when input type is everything from touch to mouse/ trackpad
})();
